(function () {
    'use strict';

    angular.module('app').filter('checkBrowser', CheckBrowserFilter);

    CheckBrowserFilter.$inject = ['$window'];
    function CheckBrowserFilter($window) {
        return function () {
            const useInBrowser = (function () {
                function matchBrowser(regexp) 
                { 
                    return regexp.test($window.navigator.userAgent);
                }
                switch (true) {
                    case matchBrowser(/edg/i): return false; //"Microsoft Edge";
                    case matchBrowser(/trident/i): return false; //"Microsoft Internet Explorer";
                    case matchBrowser(/firefox|fxios/i): return true; //"Mozilla Firefox";
                    case matchBrowser(/opr\//i): return true; //"Opera";
                    case matchBrowser(/ucbrowser/i): return true; //"UC Browser";
                    case matchBrowser(/duckduckgo/i): return true; //"DuckDuckGo";
                    case matchBrowser(/samsungbrowser/i): return true; //"Samsung Browser";
                    case matchBrowser(/chrome|chromium|crios/i): return true;//"Google Chrome";
                    case matchBrowser(/safari/i): return true; //"Apple Safari";
                    default: return false; //"Other";
                }
            })();

            return useInBrowser;
        };
    }
})();
